import { Col, Row, Skeleton } from 'ui';

const DonationsSkeletonRow = ({ length }: { length: number }) => (
  <Row>
    {Array.from({ length }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      <Col key={index} span={6} textAlign="center">
        <Skeleton.Avatar />
        <Skeleton paragraph={{ rows: 2 }} title={{ style: { display: 'none' } }} />
      </Col>
    ))}
  </Row>
);

export default DonationsSkeletonRow;
